<template>
  <b-modal id="createRegionUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmregionuserdata.createRegionUserDataModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="region">
      <b-col>
        <Create :region="region"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../Create.vue'
export default {
  name: 'EXCMRegionUserDataCreateModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmregionuserdata.create.show
    },
    regionObject () {
      return this.$store.state.modals.excmregionuserdata.create.region
    },
    close () {
      return this.$store.state.modals.excmregionuserdata.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'regionObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      region: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.regionObject) {
        this.region = Object.assign({}, this.regionObject)
        this.$store.state.modals.excmregionuserdata.create.show = 0
        this.$store.state.modals.excmregionuserdata.create.region = null
        this.$bvModal.show('createRegionUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmregionuserdata.create.close = 0
      }
      this.$bvModal.hide('createRegionUserDataModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
